module.exports = __webpack_public_path__ + "static/media/SR.a189e578.svg";